import difference from "lodash/difference";
import find from "lodash/find";
import reject from "lodash/reject";
import some from "lodash/some";
import sortBy from "lodash/sortBy";

import Button from "acl-ui/components/Button";
import PropTypes from "prop-types";
import React from "react";
import services from "../../../services/glue/appGlue";

class UserSelector extends React.Component {
  constructor(props) {
    super(props);

    // function binding
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

    this.state = {
      selectedUsers: props.selectedUsers,
      selectedGroups: props.selectedGroups,
      filterString: "",
    };
  }

  filterMatches(...attributes) {
    return some(attributes, attribute => {
      return attribute && attribute.toLowerCase().indexOf(this.state.filterString.toLowerCase()) > -1;
    });
  }

  getUserRows() {
    let users = sortBy(this.props.users, user => {
      return user.name.toLowerCase();
    });
    return users.map(user => {
      let userRow;
      if (this.state.filterString === "" || this.filterMatches(user.name, user.email)) {
        userRow = (
          <UserSelectorRow
            isSelected={this.isUserSelected(user.id)}
            userId={user.id}
            onClick={this.handleRowClick}
            name={user.name}
          >
            <span className="email">({user.email})</span>
          </UserSelectorRow>
        );
      }
      return userRow;
    });
  }

  getGroupRows() {
    let groups = sortBy(this.props.groups, group => {
      return group.name.toLowerCase();
    });
    return groups.map(group => {
      let usersList = this.getGroupUsersList(group.users);
      let usersEmails = group.users
        .map(function(user) {
          return user.email;
        })
        .toString();

      let groupRow;
      if (this.state.filterString === "" || this.filterMatches(group.name, usersList, usersEmails)) {
        groupRow = (
          <UserSelectorRow
            isSelected={this.isGroupSelected(group.id)}
            groupId={group.id}
            onClick={this.handleRowClick}
            name={group.name}
          >
            <span className="user-list">{usersList}</span>
          </UserSelectorRow>
        );
      }

      return groupRow;
    });
  }

  getGroupUsersList(users) {
    let usersList = "(";
    users.forEach(function(user, index) {
      if (index > 0) usersList += ", ";
      if (index === users.length - 1) usersList += "and ";
      usersList += user.name;
    });
    usersList += ")";

    return usersList;
  }

  handleConfirm(e) {
    this.clearFilter();
    let usersAdded = difference(this.state.selectedUsers, this.props.selectedUsers).map(userId => {
      return find(this.props.users, function(user) {
        return user.id === userId;
      });
    });
    let usersRemoved = difference(this.props.selectedUsers, this.state.selectedUsers).map(userId => {
      return find(this.props.users, function(user) {
        return user.id === userId;
      });
    });
    let groupsAdded = difference(this.state.selectedGroups, this.props.selectedGroups).map(groupId => {
      return find(this.props.groups, function(group) {
        return group.id === groupId;
      });
    });
    let groupsRemoved = difference(this.props.selectedGroups, this.state.selectedGroups).map(groupId => {
      return find(this.props.groups, function(group) {
        return group.id === groupId;
      });
    });
    this.props.onUsersSelected(
      { added: usersAdded, removed: usersRemoved },
      { added: groupsAdded, removed: groupsRemoved }
    );
  }

  handleCancel(e) {
    this.clearFilter();
    this.props.onCancel(e);
  }

  handleRowClick(userId, groupId) {
    if (userId) {
      let userIndex = this.state.selectedUsers.indexOf(userId);
      if (userIndex > -1) {
        this.setState({
          selectedUsers: reject(this.state.selectedUsers, function(id) {
            return id === userId;
          }),
        });
      } else {
        this.setState({
          selectedUsers: this.state.selectedUsers.concat([userId]),
        });
      }
    } else if (groupId) {
      if (this.state.selectedGroups.indexOf(groupId) > -1) {
        this.setState({
          selectedGroups: reject(this.state.selectedGroups, function(id) {
            return id === groupId;
          }),
        });
      } else {
        this.setState({
          selectedGroups: this.state.selectedGroups.concat([groupId]),
        });
      }
    }
  }

  handleFilterChange(e) {
    this.setState({ filterString: e.target.value });
  }

  clearFilter() {
    this.setState({ filterString: "" });
  }

  isUserSelected(userId) {
    return this.state.selectedUsers.indexOf(userId) > -1;
  }

  isGroupSelected(groupId) {
    return this.state.selectedGroups.indexOf(groupId) > -1;
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedUsers: nextProps.selectedUsers,
      selectedGroups: nextProps.selectedGroups,
    });
  }

  render() {
    return (
      <div>
        <div className="user-selector-wrapper">
          <div className="search-panel">
            <i className="acl-i-search" />
            <input
              type="text"
              value={this.state.filterString}
              onChange={this.handleFilterChange}
              placeholder={services.Localize.getLocalizedString(
                "_Storyboards.SharePanel.UserSelector.FilterUserPlaceholder_"
              )}
            />
          </div>
          <div ref="userGroupList" className="selection">
            <div className="selection__sub-header">
              <span className="selection__sub-header-text">
                {services.Localize.getLocalizedString("_Storyboards.SharePanel.UserSelector.GroupSubheader_")}
              </span>
            </div>
            <div>{this.getGroupRows()}</div>
            <div className="selection__sub-header">
              <span className="selection__sub-header-text">
                {services.Localize.getLocalizedString("_Storyboards.SharePanel.UserSelector.UserSubheader_")}
              </span>
            </div>
            <div>{this.getUserRows()}</div>
          </div>
        </div>
        <div className="selection__actions">
          <Button onClick={this.handleConfirm} type="primary">
            {services.Localize.getLocalizedString("_Storyboards.SharePanel.UserSelector.ConfirmBtn_")}
          </Button>
          <Button onClick={this.handleCancel} type="minor">
            {services.Localize.getLocalizedString("_Storyboards.SharePanel.UserSelector.CancelBtn_")}
          </Button>
        </div>
      </div>
    );
  }
}

UserSelector.propTypes = {
  users: PropTypes.array,
  groups: PropTypes.array,
  onUsersSelected: PropTypes.func,
  onCancel: PropTypes.func,
};

window.UserSelector = UserSelector;
